import { FavoriteMilitaryOccupation } from '@cpd-app/core-module/models';
import { UserReclassifying } from '@cpd-app/generated';
import { createAction, props } from '@ngrx/store';

export const loadMilitaryFavoriteOccupations = createAction(
  '[FavoriteMilitaryOccupations] Load Military Favorite Occupations'
);

export const favoriteMilitaryOccupationsLoadedSuccess = createAction(
  '[FavoriteMilitaryOccupations] Military Favorite Occupations Loaded Success',
  props<{ favoriteMilitaryOccupations: FavoriteMilitaryOccupation[] }>()
);

export const addMilitaryFavoriteOccupation = createAction(
  '[FavoriteMilitaryOccupations] Add Military Favorite Occupation',
  props<{ mocCode: string; mocTitle: string }>()
);

export const favoriteMilitaryOccupationAddedSuccess = createAction(
  '[FavoriteMilitaryOccupations] Military Favorite Occupation Added Success',
  props<{ favoriteMilitaryOccupation: FavoriteMilitaryOccupation }>()
);

export const loadUserReclassifying = createAction(
  '[FavoriteMilitaryOccupations] Load User Reclassifying'
);

export const userReclassifyingSuccess = createAction(
  '[FavoriteMilitaryOccupations] User Reclassifying Loaded Success',
  props<{ userReclassifying: UserReclassifying }>()
);

export const updateReclassifying = createAction(
  '[FavoriteMilitaryOccupations] User Reclassifying update',
  props<{ transitionfrommilitary: boolean; stayincurrent: boolean }>()
);

export const updateReclassifyingSuccess = createAction(
  '[FavoriteMilitaryOccupations] User Reclassifying update Success',
  props<{ userReclassifying: UserReclassifying }>()
);

export const removeMilitaryFavoriteOccupation = createAction(
  '[FavoriteMilitaryOccupations] Remove Military Favorite Occupation',
  props<{ mocCode: string; mocTitle: string }>()
);

export const favoriteMilitaryOccupationRemovedSuccess = createAction(
  '[FavoriteMilitaryOccupations] Military avorite Occupation Removed Success',
  props<{ mocCode: string; mocTitle: string }>()
);

export const loadSimilarMilitaryOccupationsSuccess = createAction(
  '[FavoriteMilitaryOccupations] Load Similary Military Occupation Success',
  props<{ occupations: FavoriteMilitaryOccupation[] }>()
);

export const loadSimilarMilitaryOccupationsFailed = createAction(
  '[FavoriteMilitaryOccupations] Load Similary Military Occupation Failed'
);

export const loadSimilarMilitaryOccupations = createAction(
  '[FavoriteMilitaryOccupations] Load Similar Military Occupations',
  props<{
    onetCode: string;
    search?: string;
  }>()
);
export const loadMilitaryOccupationsForGoal = createAction(
  '[FavoriteMilitaryOccupations] Load Military Occupations For Goal',
  props<{
    search?: string;
  }>()
);

export const loadMilitaryOccupationsForGoalSuccess = createAction(
  '[FavoriteMilitaryOccupations] Load Similary Military Occupation for Goal Success',
  props<{ occupations: FavoriteMilitaryOccupation[] }>()
);

export const loadMilitaryOccupationsForGoalFailed = createAction(
  '[FavoriteMilitaryOccupations] Load Military Occupations for Goal Failed'
);
